<template>
  <g-page-wrapper>
    <template slot="pageTitle">
      <g-page-title :paths="paths" v-if="this.userInfo.auth !== AUTH_GROUP.AccountManager">
        <template #title>
          <span class="-font-weight-regular">{{ $t('pages_sales_info.title') }}</span> <span class="-border-left -mx-2 -font-size-12"></span> <span class="-font-weight-medium">{{ customerName }}</span>
        </template>
      </g-page-title>
      <g-page-title v-if="this.userInfo.auth === AUTH_GROUP.AccountManager">
        <template #title>
          <span class="-font-weight-regular">{{ $t('pages_sales_info.menu_parent') }}</span>
        </template>
      </g-page-title>
    </template>
    <g-contents>
      <div class="-tile-container -py-5">
        <div class="-tile-container -wrapper fitting- nowrap-">
          <sales-info-bill-info />
          <div class="-tile-container">
            <sales-info-cost-trend-month />
            <sales-info-cost-by-invoice @customerName="setCustomerName"/>
          </div>
        </div>
      </div>
    </g-contents>
  </g-page-wrapper>
</template>

<script>
import SalesInfoBillInfo from './components/SalesInfoBillInfo'
import SalesInfoCostByInvoice from './components/SalesInfoCostByInvoice'
import SalesInfoCostTrendMonth from './components/SalesInfoCostTrendMonth'
import {AUTH_GROUP} from "@/constants/constants";
import {mapGetters, mapActions} from "vuex";

export default {
  components: {
    SalesInfoBillInfo,
    SalesInfoCostByInvoice,
    SalesInfoCostTrendMonth
  },
  data () {
    return {
      paths: [
        {
          name: this.$t('pages_sales_info.menu_parent'),
          path: '/sales/payment'
        },
        {
          name: this.$t('pages_sales_info.menu_children'),
        },
      ],
      detail : {},
      customerName: '',
      invoiceParam: {},
      AUTH_GROUP: AUTH_GROUP

    }
  },
  computed:{
    ...mapGetters('user', ['userInfo']),
    ...mapGetters('dashboard', ['customerList']),
    ...mapGetters('bills', ['invoices'])

  },
  methods: {
    ...mapActions('dashboard', ['getCustomers']),
    setCustomerName(data) {
      this.customerName = data
    }
  },
  mounted() {
    this.invoiceParam = this.$route.query
    this.customerName = ''

  },
  watch: {
    invoiceParam() {
      if(this.userInfo.auth === AUTH_GROUP.AccountManager){
        if(this.userInfo.customerCode !== this.invoiceParam.customerCode){
          this.$showToast(this.$t('common.no_authorization'))
          this.$router.push("/")
        }
      }
      if(this.userInfo.auth === AUTH_GROUP.BespinSales){
        if(this.userInfo.userEmail !== this.invoiceParam.userEmail){
          this.$showToast(this.$t('common.no_authorization'))
          this.$router.push("/")
        }
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/sales/SalesInfo.vue